export default "__VITE_ASSET__f769ec83__"